import { Pipe, PipeTransform } from '@angular/core';
import { TaskActionV2, TaskV2 } from '../types';

const prettyNameMap: Record<TaskActionV2, string> = {
  pickup: 'Pickup',
  dropoff: 'Drop Off',
  backhaul_pickup: 'Backhaul Pickup',
  backhaul_dropoff: 'Backhaul Drop Off',
  unknown: 'Unknown',
  other: 'Other',
  boxPickup: 'Box Pickup',
  assetPickup: 'Asset Pickup',
  assetDropoff: 'Asset Dropoff',
  return: 'Return',
};

@Pipe({
  name: 'taskType',
})
export class TaskTypePipe implements PipeTransform {
  public transform(value: TaskV2[]): string[] {
    return value.map((value1) => prettyNameMap[value1.action]);
  }
}
